"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var date_fns_1 = require("date-fns");
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var UserContext_1 = __importDefault(require("@/frontend/react/context/UserContext"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var senderName = function (_a) {
    var message = _a.message, sentByYou = _a.sentByYou;
    if (message.isSystemMessage) {
        return "".concat(trans_1.default.get('labels.general.system'), " ");
    }
    if (sentByYou) {
        return null;
    }
    return "".concat(message.senderName, " ");
};
function Message(_a) {
    var message = _a.message;
    var user = (0, react_1.useContext)(UserContext_1.default);
    var sentByYou = (0, react_1.useMemo)(function () {
        return message.senderId === user.userId;
    }, [message.senderId, user.userId]);
    var createdAtString = (0, react_1.useMemo)(function () {
        var date = new Date(message.createdAt * 1000);
        if ((0, date_fns_1.isToday)(date)) {
            return (0, date_fns_1.format)(date, 'H:mm');
        }
        return (0, date_fns_1.format)(date, 'dd-MM-yyyy H:mm');
    }, [message.createdAt]);
    var backgroundColor = (0, react_1.useMemo)(function () {
        if (message.isSystemMessage) {
            return 'lightgray';
        }
        if (sentByYou) {
            return '#25d366';
        }
        return '#F9F9F9';
    }, [message.isSystemMessage, sentByYou]);
    var messageAlign = (0, react_1.useMemo)(function () {
        if (message.isSystemMessage) {
            return 'center';
        }
        if (sentByYou) {
            return 'right';
        }
        return 'left';
    }, [message.isSystemMessage, sentByYou]);
    var textMessageAlign = (0, react_1.useMemo)(function () {
        if (message.isSystemMessage) {
            return 'center';
        }
        return 'left';
    }, [message.isSystemMessage]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ css: {
            textAlign: messageAlign,
            marginTop: 10,
            marginBottom: 10,
        } }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ css: {
                backgroundColor: backgroundColor,
                padding: '5px 12px',
                borderRadius: 10,
                display: 'inline-block',
                margin: 0,
                maxWidth: '80%',
                wordBreak: 'break-all',
                textAlign: textMessageAlign,
            } }, { children: [(0, jsx_runtime_1.jsxs)("p", __assign({ css: {
                        margin: '0 0 6px 0',
                        fontSize: 10,
                        color: '#666',
                    } }, { children: [senderName({ message: message, sentByYou: sentByYou }), createdAtString] })), (0, html_react_parser_1.default)(message.content)] })) })));
}
exports.default = Message;
